import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import {
  generationLosses,
  genLossesMultiple,
} from "../../Functions/generationCalculate";
import {
  canPlaceImage,
  canPlaceImageInside,
  isImageInsideObstacle,
  isImageInsideObstacleRotation,
  isPositionFree,
} from "../canvasFunction";
import { roofStructureData } from "../structureFunction";

export const getPixelsPerMeter = (roofInfo) => {
  const earthCircumference = 40075016.686; // in meters
  const latitude = roofInfo?.value?.siteAddress?.coordinates?.lat;
  const mapOption = roofInfo?.value?.mapOption;
  const zoom = mapOption?.zoom;
  let pixelsPerMeter = 0;

  if (mapOption.mapTypeId === "gridView") {
    pixelsPerMeter = roofInfo.value.pixelValue * 3.28084;
  } else {
    // Calculate meters per pixel (mpp)
    const metersPerPixel =
      (earthCircumference * Math.cos((latitude * Math.PI) / 180)) /
      Math.pow(2, zoom + 8);
    // Calculate pixels per meter
    pixelsPerMeter = Number((1 / metersPerPixel).toFixed(4));
  }

  return pixelsPerMeter;
};

export const handleSmithStrDim = ({
  roofInfo,
  roofDetail,
  panel,
  structureItem,
}) => {
  //Get pixel val
  let pixelMultiple = getPixelsPerMeter(roofInfo);

  // Find the image Dimension
  let width = panel.width;
  let height = panel.height;
  let tiltAngle = roofDetail.tiltAngle;
  if (roofDetail.roofType === "Shed Roof") {
    tiltAngle = 0;
  }
  if (structureItem.orientation === "Landscape") {
    width = panel.height;
    height = panel.width;
  }
  const angle = (tiltAngle * Math.PI) / 180;
  let hyp =
    height * structureItem.rowFrame +
    (structureItem.rowFrame - 1) * (structureItem.moduleSpacing / 1000) +
    0.2;

  if (structureItem.roofType !== "Shed Roof") {
    hyp += 0.1;
  }

  const base = hyp * Math.cos(angle);
  let perp = hyp * Math.sin(angle) * 1.5 + structureItem.frontHeight / 1000;

  if (structureItem.roofType === "Shed Roof") {
    perp = roofDetail.frameSpacing / 1000;
  }

  const imgDimension = {
    height: Number((base * pixelMultiple).toFixed(2)),
    width: Number((width * structureItem.colFrame * pixelMultiple).toFixed(2)),
    gap: Number((perp * pixelMultiple).toFixed(2)),
    rowDistance: Number(perp.toFixed(5)),
    orientation: roofDetail.orientation,
    rowFrame: structureItem.rowFrame,
    colFrame: structureItem.colFrame,
    moduleSpacing: Number(
      ((roofDetail.moduleSpacing / 1000) * pixelMultiple).toFixed(2)
    ),
    frameSpacing: Number(
      ((roofDetail.frameSpacing / 1000) * pixelMultiple).toFixed(2)
    ),
    walkWaySpacing: Number((roofDetail.roadSpace * pixelMultiple).toFixed(2)),
    pixelMultiple: pixelMultiple,
  };

  return imgDimension;
};

export const handleSmith = ({
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  limitCapacity,
  quantityInfo,
  roofDetail,
  panel,
}) => {
  if (roofDetail.roofType === "Select") {
    alert("First of all select any roof type.");
    return false;
  }
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];

  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    structureItem,
    panel,
  });

  let pixelMultiple = imgDimension?.pixelMultiple || 0;

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));

  if (roofDetail.customCapacityType === "Custom") {
    imgDimension.gap = (roofDetail.rowDistance / 1000) * pixelMultiple;
  }

  const angleDegrees = 0;
  let x = minX;
  let y = minY + pixelMultiple * 0.305;
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY) {
    while (x <= maxX) {
      if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        if (col === 1) {
          x += pixelMultiple * 0.305;
          isFirstRowPlaced = true;
          row++;
          if (row === 1) {
            y += pixelMultiple * 0.305;
          }
        }

        const imageId =
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

        const newImage = {
          id: imageId,
          x: x,
          y: y,
          angleDegree: 0,
          width: imgDimension.width,
          height: imgDimension.height,
          gap: imgDimension.gap,
          rowFrame: imgDimension.rowFrame,
          colFrame: imgDimension.colFrame,
          moduleSpacing: imgDimension.moduleSpacing,
        };
        newImages.push(newImage);
        if (
          col % roofDetail.walkWayCol === 0 &&
          roofDetail.walkWayCol !== 0 &&
          roofDetail.walkWayType === "With"
        ) {
          x += imgDimension.width + imgDimension.walkWaySpacing;
        } else {
          x += imgDimension.width + imgDimension.frameSpacing;
        }
      } else {
        x += 1;
      }
    }
    col = 0;
    x = minX;
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.height + imgDimension.gap;
    }
  }

  calSmithStr({
    newImages,
    dispatch,
    roofDetail,
    quantityInfo,
    imgDimension,
    roofInfo,
    panel,
    structureItem,
  });
};

export const calSmithStr = ({
  newImages,
  dispatch,
  roofDetail,
  quantityInfo,
  imgDimension,
  roofInfo,
  panel,
  structureItem,
}) => {
  // Need to update
  let noOfPvModule = Object.values(newImages).reduce(
    (sum, value) => sum + value.rowFrame * value.colFrame,
    0
  );
  const totalKilowatt = (noOfPvModule * (panel.pMax / 1000)).toFixed(1);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? Number((imgDimension.rowDistance * 1000).toFixed(2))
      : roofDetail.rowDistance;

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    customCapacity: totalKilowatt,
    pvModule: noOfPvModule,
    mountingStructure: structureItem.name,
    rowDistance: rowDistance,
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    jointer: 0,
    rails: 0,
    azimuth: 180,
    multipleStructure: [],
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  if (structureItem.shared) {
    calculatedSharedP({
      newImages,
      dispatch,
      structureItem,
      quantityInfo,
      noOfPvModule,
      panel,
    });
  } else {
    calculateWithoutShared({
      newImages,
      dispatch,
      structureItem,
      quantityInfo,
    });
  }

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};

const calculateWithoutShared = ({
  newImages,
  dispatch,
  structureItem,
  quantityInfo,
}) => {
  const totalStructure = newImages.length;
  const endClamp = totalStructure * structureItem.endClamp;
  const midClamp = totalStructure * structureItem.midClamp;

  const myObject = {
    midClamp: midClamp,
    endClamp: endClamp,
    totalStructure: totalStructure,
    railLength: 0,
    newStructure: true,
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );
};

const calculatedSharedP = ({
  newImages,
  dispatch,
  structureItem,
  quantityInfo,
  noOfPvModule,
  panel,
}) => {
  const shareDetail = {
    endClamp: 0,
    midClamp: 0,
    noOfStructure: 0,
    rails: 0,
    railLength: 0,
    walkWayLength: 0,
    newStructure: true,
    totalStructure: 0,
    jointer: 0,
    beam: 0,
  };

  const grouped = newImages.reduce((acc, item) => {
    const key = String(item.y); // ensure it's a string key
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {}); // plain object, extensible

  Object.values(grouped).forEach((ele) => {
    let col = 0;
    const arr = ele.sort((a, b) => a.x - b.x);
    for (let i = 0; i < arr.length; i++) {
      const ele = arr[i];
      const ele2 = i < arr.length - 1 ? arr[i + 1] : ele;
      const check = ele.width.toFixed(2);
      const len = (ele2.x - ele.x - ele.moduleSpacing).toFixed(2);
      if (len === check) {
        shareDetail.midClamp += 2 * ele.rowFrame;
        col++;
      } else {
        col++;
        shareDetail.endClamp += 4 * structureItem.rowFrame;
        if (structureItem.mountStructure) {
          const block = Number((col / 3).toFixed(0));
          shareDetail.beam += block + 1;
          shareDetail.jointer += block >= 1 ? block - 1 : 0;
        }
        col = 0;
      }
    }
  });

  const totalClamp = shareDetail.endClamp + shareDetail.midClamp;

  let railLength = 0;

  if (newImages.length > 0) {
    const panelWidth = panel.width * 1000;
    const val = 2 * noOfPvModule * panelWidth + totalClamp * 25;

    railLength = Number((val / 304.8).toFixed(2));
  }
  if (structureItem.throughRail) {
    shareDetail.railLength = Number(
      (railLength + (railLength * 4) / 100).toFixed(2)
    );
  }
  if (structureItem.rails) {
    shareDetail.rails = totalClamp;
  }

  if (structureItem.name === "Smith P1 with Perlin") {
    shareDetail.totalStructure = noOfPvModule;
  } else if (structureItem.name === "Smith P2") {
    shareDetail.totalStructure = "--";
  } else {
    shareDetail.totalStructure =
      (shareDetail.midClamp + shareDetail.endClamp) / 2;
  }

  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: shareDetail,
    })
  );
};

export const SmithFlatPanelRotation = ({
  dispatch,
  abstacles,
  roofInfo,
  gridInfo,
  designParameter,
  structureItem,
  quantityInfo,
  value,
  changeAzimuth,
}) => {
  const roofData = quantityInfo.roofData;
  const index = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[index] : [];

  if (roofDetail.roofType === "Select") {
    alert("First of all select any roof type.");
    return false;
  }

  let limitCapacity = 0;
  let updateCondition = true;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  //Get Dimensions
  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    panel,
    structureItem,
  });

  const structureWatt = panel.pMax;
  if (roofDetail.customCapacity !== 0 && designParameter.customCapacityCheck) {
    limitCapacity = (
      roofDetail.customCapacity /
      (structureItem.structureWatt * (structureWatt / 1000))
    ).toFixed();
  }

  let azimuth = roofDetail.azimuth;
  if (value === "up") {
    azimuth++;
  } else if (value === "down") {
    azimuth--;
  } else if (changeAzimuth) {
    azimuth = changeAzimuth;
  }

  let angleDegrees;
  if (azimuth >= 180) {
    angleDegrees = azimuth - 180;
  } else {
    angleDegrees = azimuth + 180;
  }

  /////////////////////////////////////////
  let row = roofDetail.blockRow;
  let col = roofDetail.blockCol;
  if (roofDetail.walkWayType === "With") {
    row = 0;
    col = roofDetail.walkWayCol;
  }

  // The isssue is come due to above lines work on it

  const colVal = col === 0 ? 10 : col;
  let factor = 500 + (500 % colVal);
  let walkway =
    gridInfo.unit === "m" ? roofDetail.walkWay : roofDetail.walkWay * 0.3048;
  let space = walkway * 20;
  // let space = 0
  /////////////////////////////////////////
  let currCol = 0;
  let currRow = 0;
  if (angleDegrees === 90 || angleDegrees === 270) angleDegrees += 0.5;
  if (
    angleDegrees <= 0 ||
    angleDegrees === 90 ||
    angleDegrees === 270 ||
    angleDegrees >= 360
  ) {
    return;
  }
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];

  ////////////////////////////////////
  walkway = roofDetail.walkWayType === "With" ? imgDimension.walkWaySpacing : 0;
  // space = imgDimension.gap;
  if (roofDetail.customCapacityType === "Custom") {
    space = (roofDetail.rowDistance / 1000) * imgDimension.pixelMultiple;
  } else {
    space = imgDimension.gap;
  }
  let proP = [];
  let pInd = 0;
  ////////////////////////////////////

  let newImages = [];
  const polygonCoordinates = roofPolygons[index].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x,
    point.y,
  ]);
  let maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  let minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  let minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));

  let angle = angleDegrees * (Math.PI / 180);

  const width = imgDimension.width + imgDimension.frameSpacing;
  console.log(width);

  if (
    (angleDegrees < 90 && angleDegrees > 0) ||
    (angleDegrees > 180 && angleDegrees < 270)
  ) {
    let x = maxX;

    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    // let offVal = maxY + maxX;
    while (x > minX - offVal) {
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;
      proP[pInd] = [];
      while (currX >= minX - offVal && currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          const imageId =
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
          newImages.push({
            id: imageId,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }
      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;
      currCol = 0;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
      // x-=50;
      // y-=500;
    }
    let y = testY;
    while (y < maxY) {
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;

      currCol = 0;
      proP[pInd] = [];
      while (currX <= maxX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          const imageId =
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
          newImages.push({
            id: imageId,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX += Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX += Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * Math.abs(1 * imgDimension.width * Math.cos(angle)) -
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(1 * imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  } else {
    let x = minX;
    let testY = minY + imgDimension.height * 0.3;

    let offVal = 0;
    while (x < maxX + offVal) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = testY + designParameter.yValue;

      currCol = 0;
      while (currX < maxX + offVal && currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          const imageId =
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
          newImages.push({
            id: imageId,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }

        currCol++;
        if (currCol === col) {
          currX -= Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }

      // If the current proP[pInd] is not empty then increment
      if (proP[pInd].length > 0) pInd++;

      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.cos(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        testY =
          testY -
          Math.abs(
            (factor * imgDimension.width + (factor / colVal) * walkway) *
              Math.sin(angle)
          ) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
    let y = testY;
    while (y < maxY) {
      proP[pInd] = [];
      newImages = [...newImages];
      let currX = x + designParameter.xValue;
      let currY = y + designParameter.yValue;
      currCol = 0;
      while (currX >= minX && currY <= maxY) {
        if (limitCapacity !== 0 && newImages.length >= limitCapacity) {
          updateCondition = false;
        }
        if (
          updateCondition &&
          canPlaceImageInside(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            polygonCoordinates
          ) &&
          isImageInsideObstacleRotation(
            currX,
            currY,
            imgDimension.width,
            imgDimension.height,
            angle,
            abstacles
          )
        ) {
          const imageId =
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
          newImages = [...newImages];
          newImages.push({
            id: imageId,
            x: currX,
            y: currY,
            width: imgDimension.width,
            height: imgDimension.height,
            type: structureItem.name,
            gap: imgDimension.gap,
            angleDegree: angleDegrees,
            rowFrame: imgDimension.rowFrame,
            colFrame: imgDimension.colFrame,
            moduleSpacing: imgDimension.moduleSpacing,
          });
          proP[pInd].push({ currX, currY });
        }
        currCol++;
        if (currCol === col) {
          currX -= Math.abs((width + walkway) * Math.cos(angle));
          currY += Math.abs((width + walkway) * Math.sin(angle));
          currCol = 0;
        } else {
          currX -= Math.abs(width * Math.cos(angle));
          currY += Math.abs(width * Math.sin(angle));
        }
      }

      if (proP[pInd].length > 0) pInd++;
      currRow++;
      if (currRow % row === 0 && currRow !== 0) {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + walkway + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + walkway + space) * Math.cos(angle));
      } else {
        x =
          x +
          0 * imgDimension.width * Math.cos(angle) +
          Math.abs((imgDimension.height + space) * Math.sin(angle));
        y =
          y +
          0 * Math.abs(imgDimension.width * Math.sin(angle)) +
          Math.abs((imgDimension.height + space) * Math.cos(angle));
      }
    }
  }
  if (proP.length > 0 && proP[pInd].length === 0) proP.pop();
  // Panel Calculations
  calculatedRotateStr({
    newImages,
    proP,
    structureItem,
    imgDimension,
    dispatch,
    quantityInfo,
    roofInfo,
    roofDetail,
    azimuth,
  });
};

export const calculatedRotateStr = ({
  newImages,
  proP,
  imgDimension,
  structureItem,
  dispatch,
  quantityInfo,
  roofInfo,
  roofDetail,
  azimuth,
}) => {
  let groupArray = [];
  if (structureItem.orientation === "Portrait") {
    groupArray = proP;
  } else {
    let test = [...newImages];
    for (let i = 0; i < test.length; i++) {
      test[i] = { ...test[i], group: -1 };
    }

    let group = 0;
    let testAngle =
      newImages.length > 0 ? newImages[0].angleDegree : roofDetail.azimuth;
    test.forEach((item) => {
      if (item.group === -1) {
        item.group = group;
        test.forEach((item2) => {
          if (
            item2.group === -1 &&
            ((item.x > item2.x &&
              ((testAngle >= 0 && testAngle < 90) ||
                (testAngle > 180 && testAngle < 270))) ||
              (item.x < item2.x &&
                ((testAngle > 90 && testAngle < 180) ||
                  (testAngle > 270 && testAngle < 360))))
          ) {
            let angle = Math.round(
              Math.atan2(item.y - item2.y, item.x - item2.x) * (180 / Math.PI)
            );
            if (testAngle >= 0 && testAngle < 90) angle += 90;
            else if (testAngle >= 90 && testAngle < 270) angle += 270;
            else angle += 450;
            // Keep tolerance of +-3 degrees
            if (angle >= testAngle - 3 && angle <= testAngle + 3) {
              item2.group = group;
            }
          }
        });
        group++;
      }
    });

    for (let i = 0; i < group; i++) {
      groupArray.push([]);
    }
    test.forEach((item) => {
      groupArray[item.group].push({ x: item.x, y: item.y });
    });
  }

  // Panel groups separated
  let beams = 0;
  let jointer = 0;
  let mid = 0;
  let end = 0;
  let col = 1;

  groupArray.forEach((item) => {
    for (let i = 0; i < item.length; i++) {
      const ele = item[i];
      const ele2 = i < item.length - 1 ? item[i + 1] : ele;
      const check = Number(
        (imgDimension.width + imgDimension.moduleSpacing).toFixed(2)
      );

      if (structureItem.orientation === "Portrait") {
        const len = Number(
          Math.sqrt(
            Math.pow(ele.currX - ele2.currX, 2) +
              Math.pow(ele.currY - ele2.currY, 2)
          ).toFixed(2)
        );

        if (len === check) {
          mid += 2 * structureItem.rowFrame;
          col++;
        } else {
          end += 4 * structureItem.rowFrame;
          if (structureItem.mountStructure) {
            const poll = Number((col / 3).toFixed());
            beams += poll + 1;
            jointer += poll - 1;
          }
          col = 1;
        }
      } else {
        const len = Math.sqrt(
          Math.pow(ele.x - ele2.x, 2) + Math.pow(ele.y - ele2.y, 2)
        );
        if (
          Number(len.toFixed(2)) ===
          Number((imgDimension.height + imgDimension.gap).toFixed(2))
        ) {
          mid += 2;
        } else {
          end += 4;
        }
      }
    }
  });

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: 0,
    totalStructure: "--",
    pvModule: 0,
    endClamp: 0,
    midClamp: 0,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    fullRailLength: 0,
    walkWayLength: 0,
    beam: 0,
    jointer: 0,
    rails: 0,
    azimuth: azimuth,
    rowDistance: roofDetail.rowDistance,
    multipleStructure: [],
  };

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const totalKilowatt = (
    newImages.length *
    (structureItem.structureWatt * (panel.pMax / 1000))
  ).toFixed(1);

  const noOfPvModule = newImages.length * structureItem.structureWatt;

  myObject.pvModule = noOfPvModule;
  myObject.totalKilowatt = totalKilowatt;

  myObject.midClamp = mid;
  myObject.endClamp = end;
  myObject.beam = beams;
  myObject.jointer = jointer;

  let railLength = 0;
  let totalClamp = mid + end;

  if (newImages.length > 0) {
    const panelWidth = panel.width * 1000;
    const val = 2 * noOfPvModule * panelWidth + totalClamp * 25;

    railLength = Number((val / 304.8).toFixed(2));
    if (structureItem.throughRail) {
      myObject.railLength = Number(
        (railLength + (railLength * 4) / 100).toFixed(2)
      );
    } else {
      myObject.railLength = 0;
    }
  }

  if (structureItem.name === "Smith P1 with Perlin") {
    myObject.totalStructure = noOfPvModule;
  } else if (structureItem.name === "Smith P2") {
    myObject.totalStructure = "--";
  } else {
    myObject.totalStructure = totalClamp / 2;
  }

  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        ...myObject,
        proP: proP,
      },
    })
  );
  proP = Object.values(proP);

  if (
    structureItem.orientation === "Landscape" &&
    structureItem.roofType === "Flat Roof"
  ) {
    calculateWithoutShared({
      newImages,
      dispatch,
      quantityInfo,
      structureItem,
    });
    dispatch(
      updateRoofDetails({
        index: quantityInfo.roofNo,
        fields: {
          azimuth: azimuth,
        },
      })
    );
  }

  const value = { ...roofDetail, ...myObject };
  generationLosses(value, quantityInfo, dispatch);
};

//Add New Structure
export const addSmithStructure = ({
  dispatch,
  roofInfo,
  currentPos,
  quantityInfo,
}) => {
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const images = roofDetail?.images || [];

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  let structureItem = roofStructureData.find(
    (item) => item.name === roofDetail.mountingStructure
  );

  let azimuth = roofDetail?.azimuth;
  let angleDegrees;
  if (azimuth >= 180) {
    angleDegrees = azimuth - 180;
  } else {
    angleDegrees = azimuth + 180;
  }

  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    panel,
    structureItem,
  });

  const imageId =
    Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  let pro = [];
  let yVal = currentPos.y;
  let xVal = currentPos.x;
  if (angleDegrees === 0 && azimuth === 180) {
    const xImage = images.filter(
      (ite) =>
        currentPos.x - imgDimension.width - 5 <= ite.x &&
        currentPos.x + imgDimension.width / 3 >= ite.x &&
        currentPos.y - 5 <= ite.y &&
        currentPos.y + 5 >= ite.y
    );
    if (xImage.length > 0) {
      xVal =
        xImage[xImage.length - 1].x +
        imgDimension.width +
        imgDimension.frameSpacing;
      yVal = xImage[0].y;
    }
  } else {
    // let proP = roofDetail?.proP;
    // const angle = angleDegrees * (Math.PI / 180);
    // const cosA = Math.cos(angle);
    // const sinA = Math.sin(angle);
    // const xCheck = currentPos.x - Math.abs((imgDimension.width + 5) * cosA);
    // const y1Check = currentPos.y - 5 - Math.abs(imgDimension.width * sinA);
    // const y2Check = currentPos.y + 5 + Math.abs(imgDimension.width * sinA);

    // let add = false;
    // let newProP = proP.map((group) => [...group]);

    // for (let gi = 0; gi < proP.length; gi++) {
    //   let group = proP[gi];
    //   for (const p of group) {
    //     const check =
    //       xCheck <= p.currX && y1Check <= p.currY && y2Check >= p.currY;
    //     if (check) {
    //       console.log(
    //         imgDimension.width + imgDimension.frameSpacing,
    //         imgDimension.width + imgDimension.moduleSpacing
    //       );
    //       const width = imgDimension.width + imgDimension.frameSpacing;
    //       xVal = p.currX + Math.abs(imgDimension.frameSpacing * cosA);
    //       yVal = p.currY + Math.abs(imgDimension.frameSpacing * sinA);

    //       // Add new point to the corresponding group in newProP
    //       newProP[gi].push({ currX: xVal, currY: yVal });
    //       console.log(xVal, yVal);
    //       add = true;
    //       break; // break inner loop
    //     }
    //   }
    //   if (add) break; // break outer loop
    // }

    // // If no match found, create a new group
    // if (!add) {
    //   newProP.push([{ currX: currentPos.x, currY: currentPos.y }]);
    // }

    // pro = newProP.map((group) => [...group]);

    let proP = roofDetail?.proP;
    let newProP = proP.map((group) => [...group]);
    if (structureItem.orientation === "Portrait") {
      newProP.push([{ currX: currentPos.x, currY: currentPos.y }]);
    } else {
      newProP.push([{ x: currentPos.x, y: currentPos.y }]);
    }
    xVal = currentPos.x;
    yVal = currentPos.y;
    pro = newProP.map((group) => [...group]);
  }

  const newImage = {
    id: imageId,
    x: xVal,
    y: yVal,
    angleDegree: angleDegrees,
    type: structureItem.name,
    orientation: structureItem.orientation,
    width: imgDimension.width,
    height: imgDimension.height,
    gap: imgDimension.gap,
    rowFrame: imgDimension.rowFrame,
    colFrame: imgDimension.colFrame,
    moduleSpacing: imgDimension.moduleSpacing,
  };

  const newImages = [...images, newImage];

  if (roofDetail.structureType === "Multiple") {
    calMultipleStr(newImages, dispatch, quantityInfo, panel);
  } else {
    if (angleDegrees === 0) {
      calSmithStr({
        newImages,
        dispatch,
        roofDetail,
        quantityInfo,
        imgDimension,
        roofInfo,
        panel,
        structureItem,
      });
    } else {
      calculatedRotateStr({
        newImages,
        proP: pro,
        structureItem,
        imgDimension,
        dispatch,
        quantityInfo,
        roofInfo,
        roofDetail,
        azimuth,
      });
    }
  }
};

//Deleted Image
export const strImgDeleted = ({
  dispatch,
  quantityInfo,
  roofInfo,
  selectedImage,
  panel,
  structureItem,
}) => {
  const roofNo = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofNo];

  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    panel,
    structureItem,
  });

  const images = roofDetail?.images || [];
  const newImages = [...images];
  if (Array.isArray(selectedImage)) {
    selectedImage.forEach((image) => {
      const indexToDelete = newImages.findIndex((img) => img.id === image.id);
      if (indexToDelete !== -1) {
        newImages.splice(indexToDelete, 1);
      }
    });
  } else {
    const indexToDelete = newImages.findIndex(
      (img) => img.id === selectedImage.id
    );
    if (indexToDelete !== -1) {
      newImages.splice(indexToDelete, 1);
    }
  }
  //calculation
  calSmithStr({
    newImages,
    dispatch,
    roofDetail,
    quantityInfo,
    imgDimension,
    roofInfo,
    panel,
    structureItem,
  });
};

export const rotatedImgDelete = ({
  dispatch,
  quantityInfo,
  roofInfo,
  selectedImage,
  panel,
  structureItem,
}) => {
  const roofNo = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofNo];

  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    panel,
    structureItem,
  });

  const azimuth = roofDetail.azimuth;
  let proP = roofDetail.proP;
  proP = Object.values(proP);
  let newImages = roofDetail.images;

  if (Array.isArray(selectedImage)) {
    selectedImage.forEach((image) => {
      newImages = newImages.filter((img) => img.x !== image.x);
      // Delete from proP as well
      let proPTemp = [];
      proP.forEach((item) => {
        let temp = item.filter((img) => (img?.currX ?? img.x) !== image.x);
        if (temp.length > 0) {
          proPTemp.push(temp);
        }
      });
      proP = proPTemp;
    });
  } else {
    newImages = newImages.filter((img) => img.x !== selectedImage.x);
    // Delete from proP as well
    let proPTemp = [];
    proP.forEach((item) => {
      let temp = item.filter(
        (img) => (img?.currX ?? img.x) !== selectedImage.x
      );
      if (temp.length > 0) {
        proPTemp.push(temp);
      }
    });
    proP = proPTemp;
    console.log(proPTemp);
  }

  calculatedRotateStr({
    newImages,
    proP,
    structureItem,
    imgDimension,
    dispatch,
    quantityInfo,
    roofInfo,
    roofDetail,
    azimuth,
  });
};

export const mulImgDelete = ({
  dispatch,
  quantityInfo,
  selectedImage,
  panel,
}) => {
  const roofNo = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofNo];

  const newImages = roofDetail?.images || [];
  const images = [...newImages];

  if (Array.isArray(selectedImage)) {
    selectedImage.forEach((image) => {
      const indexToDelete = images.findIndex((img) => img.id === image.id);
      if (indexToDelete !== -1) {
        images.splice(indexToDelete, 1);
      }
    });
  } else {
    const indexToDelete = images.findIndex(
      (img) => img.id === selectedImage.id
    );
    if (indexToDelete !== -1) {
      images.splice(indexToDelete, 1);
    }
  }

  calMultipleStr(images, dispatch, quantityInfo, panel);
};

export const handleMultiPlace = async ({
  structureItem,
  quantityInfo,
  abstacles,
  dispatch,
  roofInfo,
}) => {
  let roofDetail = quantityInfo.roofData[quantityInfo.roofNo];
  let images = roofDetail.images;

  const roofPolygons = roofInfo.value.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const imgDimension = handleSmithStrDim({
    roofInfo,
    roofDetail,
    panel,
    structureItem,
  });

  const newImages = [];
  let updatedImages = [];
  let i = quantityInfo.roofNo;
  const polygonCoordinates = roofPolygons[i].updatedPoints;

  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x,
    point.y,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));

  const angleDegrees = 0;
  let x = minX;
  let y = minY + pixelMultiple * 0.305;

  if (images.length > 0) {
    const value =
      images[images.length - 1].y + images[images.length - 1].height;
    y = value + imgDimension.gap;
  }
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let placement = true;

  while (y <= maxY) {
    if (!(roofDetail.multiStructureRow > row)) {
      placement = false;
    }
    while (x <= maxX && placement) {
      if (
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        if (col === 1) {
          x += pixelMultiple * 0.305;
          isFirstRowPlaced = true;
          row++;
        }

        const imageId =
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

        const newImage = {
          id: imageId,
          x: x,
          y: y,
          angleDegree: 0,
          type: structureItem.name,
          orientation: structureItem.orientation,
          width: imgDimension.width,
          height: imgDimension.height,
          gap: imgDimension.gap,
          rowFrame: imgDimension.rowFrame,
          colFrame: imgDimension.colFrame,
          moduleSpacing: imgDimension.moduleSpacing,
        };
        newImages.push(newImage);
        x += imgDimension.width + imgDimension.frameSpacing;
      } else {
        x += 1;
      }
    }
    col = 0;
    x = minX;
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      y += imgDimension.height + imgDimension.gap;
    }
    updatedImages = [...images, ...newImages];
  }

  if (updatedImages.length === 0) {
    updatedImages = [...images];
  }

  calMultipleStr(updatedImages, dispatch, quantityInfo, panel);
};

export const calMultipleStr = (images, dispatch, quantityInfo, panel) => {
  const myData = [];

  var arr = images.reduce((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = [];
    }

    acc[item.type].push(item);
    return acc;
  }, {});

  Object.keys(arr).map((item) => {
    const array = arr[item];
    const elm = array[0];
    const structureItem = roofStructureData.find((ite) => ite.name === item);
    if (elm.orientation === "Landscape") {
      const totalStr = array.length;
      const pvModule =
        structureItem.rowFrame * structureItem.colFrame * totalStr;

      const value = {
        articleName: structureItem.articleName,
        totalKilowatt: Number(((pvModule * panel.pMax) / 1000).toFixed(1)),
        midClamp: totalStr * structureItem.midClamp,
        endClamp: totalStr * structureItem.endClamp,
        structureType: elm.type,
        totalStructure: totalStr,
        pvModule: pvModule,
      };
      myData.push(value);
    } else {
      let beam = 0;
      let jointer = 0;
      let mid = 0;
      let end = 0;
      let col = 1;
      for (let i = 0; i < array.length; i++) {
        const el1 = array[i];
        const el2 = i < array.length - 1 ? array[i + 1] : el1;
        const check = Number((elm.width + elm.moduleSpacing).toFixed(2));

        const len = Number((el2.x - el1.x).toFixed(2));
        if (len === check) {
          mid += 2 * structureItem.rowFrame;
          col++;
        } else {
          end += 4 * structureItem.rowFrame;
          if (structureItem.mountStructure) {
            const poll = Number((col / 3).toFixed());
            beam += poll + 1;
            jointer += poll - 1;
          }
          col = 1;
        }
      }

      const pvModule = array.length * structureItem.rowFrame;
      const totalClamp = mid + end;

      //Full Rail Length
      let fullRail = 0;
      let totalStr = 0;
      if (array.length > 0 && structureItem.mountStructure) {
        const panelWidth = panel.width * 1000;
        const val = 2 * pvModule * panelWidth + totalClamp * 25;
        const length = Number((val / 304.8).toFixed(2));
        fullRail = Number((length + (length * 4) / 100).toFixed(2));
      }

      if (structureItem.name === "Smith P1 Purlin") {
        totalStr = pvModule;
      } else if (structureItem.name === "Smith P2") {
        totalStr = "--";
      } else {
        totalStr = totalClamp / 2;
      }

      const value = {
        articleName: structureItem.articleName,
        structureType: elm.type,
        beam: beam,
        jointer: jointer,
        railLength: fullRail,
        totalKilowatt: Number(((pvModule * panel.pMax) / 1000).toFixed(1)),
        midClamp: mid,
        endClamp: end,
        totalStructure: totalStr,
        pvModule: pvModule,
      };

      myData.push(value);
    }

    return true;
  });

  let totalPVModule = Object.values(myData).reduce(
    (sum, value) => sum + value.pvModule,
    0
  );
  let totalKilowatt = Object.values(myData).reduce(
    (sum, value) => sum + value.totalKilowatt,
    0
  );

  totalKilowatt = Number(totalKilowatt.toFixed(1));

  const myObject = {
    images: images,
    structureType: "Multiple",
    totalKilowatt: totalKilowatt,
    totalStructure: "--",
    pvModule: totalPVModule,
    price: "--",
    name: "Multiple Structure",
    newStructure: true,
    railLength: 0,
    walkWayLength: 0,
    beam: 0,
    polls: 0,
    azimuth: 180,
    rowDistance: 1000,
    rails: 0,
    multipleStructure: myData,
  };

  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  genLossesMultiple(dispatch, quantityInfo, myObject);
};
